import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListMedias,
    createMedia,
    deleteMedia,
    updateMediaById,
    uploadMediaFile,
} from '../../services/apis/QBMediaAPIServices'
import { message } from 'antd'

function* saga_LoadListMedia(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(
            state => state.component_select_media.pageIndex
        )
        let page_size = yield select(
            state => state.component_select_media.pageSize
        )
        let status = yield select(state => state.component_select_media._status)
        let textSearch = yield select(
            state => state.component_select_media.lastTextSearch
        )

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status != null) status = params.status

        const response = yield call(
            getListMedias,
            page_number,
            page_size,
            status,
            ''
        )

        if (response.error.code === 200) {
            let medias = response.data
            let total = response.total

            if (medias.length > page_size) medias = medias.slice(0, page_size)

            yield put(actions.action.loadListMediasSuccess(medias))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                })
            )
        } else {
            console.error(
                'Get list medias API server error ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('(Component) Load list media error : ', ex.message)
    }
}

function* saga_SaveCurrentMedia() {
    try {
        let currentMedia = yield select(
            state => state.component_select_media.currentMedia
        )
        const file = yield select(state => state.component_select_media.file)

        // upload file
        try {
            if (file != null) {
                const responseUploadFile = yield call(uploadMediaFile, file)
                const file_url = responseUploadFile.uploaded_files[0]
                currentMedia = {
                    ...currentMedia,
                    ...{
                        url: file_url,
                    },
                }
            }
        } catch (ex) {
            console.error('Upload file error : ', ex.message)
        }

        // put to server
        let response = ''
        if (currentMedia.media_id === 0) {
            // create media
            response = yield call(createMedia, currentMedia)
        } else {
            //update media
            response = yield call(
                updateMediaById,
                currentMedia.media_id,
                currentMedia
            )
        }

        if (response.error.code === 200) {
            if (currentMedia.media_id === 0)
                message.success('Thêm tài liệu thành công')
            else message.success('Sửa tài liệu thành công')

            yield put(actions.action.loadListMedias({}))
        } else {
            console.log(
                'Save current media call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('(Component) Save current media error : ', ex.message)
    }
}

function* saga_DeleteMedia(action) {
    try {
        const { mediaId } = action.payload
        const response = yield call(deleteMedia, mediaId)

        if (response.error.code === 200) {
            message.success('Xoá tài liệu thành công')

            yield put(actions.action.loadListMedias({}))
        }
    } catch (ex) {
        console.error('(Component) Delete media error : ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(actions.action.loadListMedias({ page_size: pageSize }))
    } catch (ex) {
        console.log('(Component) Change page media size error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListMedias({ page_number: pageIndex }))
    } catch (ex) {
        console.log(
            '(Component) Change current media page error : ',
            ex.message
        )
    }
}

function* saga_SearchMedia() {
    try {
        let page_number = 1
        let page_size = yield select(
            state => state.component_select_media.pageSize
        )
        let status = yield select(state => state.component_select_media._status)
        let textSearch = yield select(
            state => state.component_select_media.textSearch
        )

        const response = yield call(
            getListMedias,
            page_number,
            page_size,
            status,
            textSearch
        )

        if (response.error.code === 200) {
            let medias = response.data
            let total = response.total

            if (medias.length > page_size) medias = medias.slice(0, page_size)

            yield put(actions.action.loadListMediasSuccess(medias))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: 1,
                })
            )
        } else {
            yield put(actions.action.loadListMediasSuccess([]))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total: 0,
                    pageIndex: 1,
                })
            )
        }
    } catch (ex) {
        console.log('search media error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_MEDIA, saga_LoadListMedia)
    yield takeEvery(actions.type.SAVE_CURRENT_MEDIA, saga_SaveCurrentMedia)
    yield takeEvery(actions.type.DELETE_MEDIA, saga_DeleteMedia)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.SEARCH_MEDIA, saga_SearchMedia)
}

export default function* qbmediaSaga() {
    yield all([fork(listen)])
}
